<div class="ratenow-user-menu">
  <a
    (click)="close()"
    [routerLink]="['account-settings/about']"
    class="ratenow-user-menu-item"
    matRipple
    matRippleColor="rgb(var(--color-primary), 0.1)"
  >
    <mat-icon class="ratenow-user-menu-item__icon icon-sm" svgIcon="mat:settings"></mat-icon>
    <div class="ratenow-user-menu-item__label">
      {{ 'user-menu.account-settings' | translate }}
    </div>
  </a>

  <div class="border-b border-divider mx-4"></div>

  <a (click)="logOut()" class="ratenow-user-menu-item" matRipple matRippleColor="rgb(var(--color-primary), 0.1)">
    <mat-icon class="ratenow-user-menu-item__icon icon-sm" svgIcon="mat:logout"></mat-icon>
    <div class="ratenow-user-menu-item__label">
      {{ 'user-menu.sign-out' | translate }}
    </div>
  </a>
</div>
